module.exports = {
	"contracts": {
		"price": "Valor",
		"plan": "Plano",
		"customer": "Cliente",
		"attributes": {
			"id": "Identificador",
			"code": "Código",
			"client": "Cliente",
			"plans": "Planos",
			"post_paid": "Pós paga",
			"value": "Valor da assinatura",
			"contract_date": "Data da contratação",
			"settings": {
				"days_to_overdue_invoice": "Dias para vencimento da fatura",
				"generate_service_tax_invoices": "Emitir notas fiscais das faturas"
			},
			"day_expiration": "Dia de vencimento",
			"url_notification": "URL para envio de notificações",
			"status": "Status",
			"periodicity": "Periodicidade",
			"quantity": "Quantidade",
			"statuses": {
				"pending": "Ativação pendente",
				"inactive": "Inativo",
				"active": "Ativo",
				"overdue": "Inadimplente",
				"canceled": "Cancelado",
				"finished": "Finalizado"
			},
			"charge_types": {
				"post_paid": "Pós pago",
				"pre_paid": "Pré pago"
			}
		},
		"placeholder": {
			"search_by_customer_name": "Buscar pelo nome do cliente",
			"url_notification": "Ex: https://exemplo.com",
			"search_by_plan_name": "Buscar pelo nome do plano",
			"name_or_email": "Nome ou email",
			"plan": "Plano",
			"status": "Status",
			"charge_type": "Tipo de cobrança",
			"email_example": "Ex. jose@try.com.br",
			"date": "26/12/2019"
		},
		"change_plan": {
			"change_plan": "Alterar plano",
			"change_plan_message": "Ao alterar o plano, será enviado um e-mail para seu cliente informando a alteração.",
			"select_plan": "Selecione um plano para continuar"
		},
		"modal_edit": {
			"confirm_change": "Confirmar alteração",
			"change_message": "Ao alterar o valor do plano, ele será aplicado a partir da próxima fatura somente para esta assinatura.",
			"wish_do_change": "Deseja realizar a <strong>alteração no plano %{contract}?</strong>",
			"plan_successfully_changed": "Plano da assinatura %{id} foi alterado."
		},
		"modal_taxes": {
			"title": "Gerenciamento de Impostos",
			"not_applied_taxes": "Impostos não vinculados a assinatura",
			"applied_taxes": "Impostos vinculados a assinatura",
			"buttons": {
				"add": "Adicionar",
				"remove": "Remover"
			}
		},
		"change_corp_due_date": {
			"title": "Trocar data de vencimento da fatura"
		},
		"modal_edit_contract": {
			"title": "Edição de contrato"
		},
		"modal_confirm_changes": {
			"title": "Confirmar alterações",
			"atention": "Verifique se as alterações estão corretas antes de confirmar",
			"message": "Ao confirmar as alterações, as mesmas serão aplicadas imediatamente e não poderão ser revertidas. Tem certeza que deseja <strong>confirmar as alterações?</strong>",
			"buttons": {
				"confirm": "Confirmar",
				"come_back": "Voltar para edição"
			}
		},
		"inactivate_automatic_debit": {
			"title": "Inativar débito automático",
			"message": "Ao cancelar o débito automático não será possível reativá-lo.",
			"inactive_confirm": "<p>Ao confirmar o cancelamento do débito automático, as cobranças posteriores deverão ser pagas de forma manual. Se o cliente desejar ele poderá cadastrar uma nova forma de débito automático no checkout de pagamento. Deseja realmente <strong> inativar o débito automático?</strong></p>",
			"buttons": {
				"inactivate_debit": "Inativar débito"
			}
		},
		"inactive_subscription": {
			"title": {
				"singular": "Inativar assinatura",
				"plural": "Inativar assinaturas"
			},
			"inactive_message": {
				"singular": "Ao inativar a assinatura, ela não poderá ser ativada novamente.",
				"plural": "Ao inativar as assinaturas, elas não poderão ser ativadas novamente."
			},
			"inactive_confirm": {
				"singular": "<p>Ao confirmar a inativação da assinatura, ela será encerrada e as cobranças posteriores não serão enviadas. Deseja realmente<strong> inativar esta assinatura?</strong></p>",
				"plural": "<p>Ao confirmar a inativação destas assinaturas, elas serão encerradas e as cobranças posteriores não serão enviadas. Deseja realmente<strong> inativar estas assinaturas?</strong></p>"
			}
		},
		"send_payment_url": {
			"title": "Reenviar link de pagamento",
			"due_date": "Digite a data de vencimento"
		},
		"edit": {
			"no_plan_error": "Existem itens da assinatura sem plano, verifique os dados e tente novamente.",
			"update_success": "Assinatura atualizada com sucesso",
			"update_fail": "Falha ao atualizar assinatura",
			"contract_preferences": "Detalhes da assinatura",
			"contract_plans": "Planos cadastrados na assinatura",
			"edit": "Editar",
			"manage_taxes": "Gerenciar impostos",
			"edit_subscription": "Editar assinatura",
			"plan": "Plano",
			"plan_value": "Valor do plano",
			"discount": "Desconto",
			"quantity": "Quantidade",
			"discount_value": "Valor do desconto",
			"recurring": "Recorrente",
			"include_discount": "Inclua descontos no plano. O desconto será aplicado na geração das faturas. Defina a quantidade de descontos que serão aplicados, ou marque a opção \"Recorrente\" para aplicar o desconto em todas as próximas faturas.",
			"edit_value_plan_message": "Altere o valor do plano referente a esta assinatura. Ao alterar o valor esta será aplicada somente para esta assinatura, sendo cobrada a partir das próximas faturas.",
			"alert_message": "Caso altere o valor do plano referente a esta assinatura, ele será aplicado a partir da próxima fatura.",
			"monthly": "Mensal",
			"description": "Descrição",
			"value": "Valor",
			"valid_value": "Digite um valor válido",
			"subscriptions": "Assinaturas",
			"alerts": {
				"success": {
					"plan_changed": "Plano da assinatura %{id} foi alterado.",
					"update": "Contrato atualizado com sucesso."
				},
				"fail": {
					"update": "Falha ao atualizar os dados do contrato."
				}
			}
		},
		"new": {
			"customer_data": "Dados do cliente",
			"periodicity": "Periodicidade",
			"quantity": "Quantidade",
			"people": "Pessoa Física",
			"enterprise": "Pessoa Jurídica",
			"include_taxes": "Incluir impostos",
			"find_customer": "Digite o nome do cliente para buscá-lo",
			"find_plan": "Digite o nome do plano para buscá-lo",
			"discount_recurring": "Desconto recorrente",
			"discount_quantity": "Qtde Desconto",
			"discount_price": "Valor do desconto",
			"create": "Criar Assinatura",
			"select_plan": "Selecione um plano",
			"select_customer": "Selecione um cliente para continuar",
			"new_contract_message": "Ao criar uma nova assinatura será enviado um e-mail ao cliente informando a contratação",
			"subscriptions": "Assinaturas",
			"popover": {
				"days_to_overdue_invoice": "Dias que serão adicionados ao vencimento das faturas. Ex: se a fatura vence dia 15 e a configuração é 5 o vencimento será dia 20"
			}
		},
		"main": {
			"subscriptions_list": "Lista de assinaturas",
			"charge_type": "Tipo de cobrança",
			"inactive_subscription": {
				"singular": "Inativar assinatura",
				"plural": "Inativar assinaturas"
			},
			"selected_items": {
				"singular": "%{count} item selecionado",
				"plural": "%{count} itens selecionados"
			},
			"code": "Código",
			"client": "Cliente",
			"plan": "Plano",
			"main_plan": "Plano principal",
			"subscription_value": "Valor da assinatura",
			"contract_date": "Data da contratação",
			"status": "Status",
			"pending": "Pendente",
			"inactive": "Inativo",
			"export_csv": "Exportar CSV"
		},
		"show": {
			"identifier": "Identificador",
			"charges_made": "Cobranças efetuadas",
			"discounts_launched": "Descontos lançados",
			"automatic_debit": "Débito automático",
			"automatic_debit_with_yapay": "Débito automático utilizando saldo Yapay",
			"separate_invoice": "Lançar fatura avulsa",
			"view_subscription": "Visualizar assinatura",
			"code": "Código",
			"discount": "Desconto",
			"customer_code": "Código Identificador do Estabelecimento",
			"plan": "Plano",
			"change_plan": "Alterar plano",
			"method_payment": "Forma de pagamento",
			"contract": "Data da ativação",
			"plans": "Planos",
			"subscription_detail": "Detalhes da assinatura",
			"contract_information": "Informações",
			"edit_subscription": "Editar assinatura",
			"inactive_subscription": "Inativar assinatura",
			"inactive_contract_plan": "Inativar plano",
			"day_expiration": "Dia do vencimento da fatura",
			"description": "Descrição",
			"value": "Valor",
			"charge_type": "Tipo de cobrança",
			"invoices": "Faturas",
			"emission_date": "Data de emissão",
			"status": "Status",
			"payment_date": "Data de pagamento",
			"show_more_invoices": "Mostrar todas as faturas",
			"resend_payment_url": "Reenviar url de pagamento",
			"add_entry": "Cobranças adicionais",
			"client": "Cliente",
			"client_type": "Tipo cliente",
			"full_name": "Nome completo",
			"mail": "E-mail",
			"cpf": "CPF",
			"cnpj": "CNPJ",
			"phone": "Telefone",
			"view_client_detail": "Ver detalhes do cliente",
			"since": "Desde",
			"person": "Pessoa Física",
			"person_customer": "Pessoa Jurídica",
			"due_date": "Dia de vencimento",
			"hide_invoices": "Ocultar",
			"send_payment_url": "Reenviar url de pagamento",
			"contract_duration": "Ilimitado",
			"actions": "Ações",
			"edit": "Editar"
		},
		"alerts": {
			"report_sent": "O relatório será enviado para o email: %{email}",
			"report_generated": "O relatório foi gerado.",
			"inactivate_debit_successfully": "Débito automático cancelado com sucesso",
			"inactivate_debit_failure": "Falha ao cancelar o débito automático",
			"create_success": "Contrato criado com sucesso!",
			"create_fail": "Falha ao criar contrato!",
			"inactivated_contract": "Assinatura %{id} inativada.",
			"inactivated_contracts": "Assinaturas inativadas.",
			"some_inactivated_contracts": "Somente algumas assinaturas foram inativadas.",
			"inactivation_error": "Não foi possível inativar a assinatura do cliente \"%{name}\".",
			"subscription_not_found": "Nenhuma assinatura encontrada",
			"email_successful": "Email com link de pagamento enviado"
		},
		"errors": {
			"required_field": "Campo obrigatório"
		},
		"formats": {
			"csv": "Assinaturas_%{subdomain}_%{today}.csv"
		},
		"labels": {
			"contract_settings": "Configurações da assinatura",
			"days_to_overdue_invoice": "Dias para o vencimento da fatura",
			"periodicity": "Período de recorrência referente em meses. Ex: 1 - mensal, 3 - trimestral, 6 - semestral.",
			"quantity": "Quantidade de vezes que a cobrança será executada. Valor 0 (zero) indica cobrança recorrente.",
			"discount_quantity": "Quantidade de vezes que o desconto será aplicado. Valor 0 (zero) indica desconto recorrente.",
			"card_expiration": "Vencimento"
		},
		"buttons": {
			"save": "Salvar",
			"come_back": "Voltar",
			"settings": "Configurações",
			"new_contract": "Criar assinatura",
			"cancel_debit": "Cancelar débito"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./~/yaml-loader!./src/lang/contracts/pt-BR.yml
// module id = 579
// module chunks = 1